/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { WarehouseDispatchRequestToJSON, WarehouseDispatchResponseFromJSON, } from '../models/index';
/**
 *
 */
export class WarehouseDispatchControllerApi extends runtime.BaseAPI {
    /**
     */
    async changeWarehouseDispatchModeRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling changeWarehouseDispatchMode().');
        }
        if (requestParameters['warehouseDispatchRequest'] == null) {
            throw new runtime.RequiredError('warehouseDispatchRequest', 'Required parameter "warehouseDispatchRequest" was null or undefined when calling changeWarehouseDispatchMode().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse/packages/{id}/dispatch`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WarehouseDispatchRequestToJSON(requestParameters['warehouseDispatchRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseDispatchResponseFromJSON(jsonValue));
    }
    /**
     */
    async changeWarehouseDispatchMode(requestParameters, initOverrides) {
        const response = await this.changeWarehouseDispatchModeRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
